import styled from 'styled-components';

export const Container = styled.div`
  &.ActivitiesItem{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin: 15px 0;
  }
  &.ForHover{
    position: relative;
    flex: 1
  }
  &.ActivityElement{
    height: 95px;
    background: #FFFFFF;
    border-radius: 10px;
    box-shadow: 5px 5px 5px #ccc;
    display: flex;
    align-items: center;
    padding: 5px 35px;
    cursor: pointer;
  }
  &.ForHover:hover > .ActivityElement{
    background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
  }
  &.ForHover:hover > .HoverImg{
    display: block;
  }
`;

export const StyledParagraph = styled.p`
  margin-bottom: 0;
  &.Time{
    color: #979797;
    width: 75px;
    margin-right: 10px;
  }
`;

export const StyledImg = styled.img`
  position: absolute;
  top: 43%;
  right: 30px;
  padding: 5px;
  cursor: pointer;
  display: none;
`;